import { ContentContainer, PageLayout, PageTitle } from "components/layout";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

import EmptyStoreState from "./components/empty-store-state";
import OperatorsTab from "./components/operators-tab";
import StoreContextHeader from "./components/store-context-header";
import UsersTab from "./components/users-tab";
import { useStoreAccessFilterActions } from "./filter/hooks/actions";
import { useStoreAccessFilterState } from "./filter/hooks/filterState";
import { AccessTab } from "./filter/types";

const StoreAccessQuery = () => {
  const { storeCode, activeTab } = useStoreAccessFilterState();
  const { updateActiveTab } = useStoreAccessFilterActions();

  return (
    <PageLayout>
      <PageTitle
        title="Consulta de Acessos"
        description="Consulte usuários e operadores por loja com validação de CPF"
      />
      <ContentContainer>
        <div className="flex flex-col gap-4">
          <StoreContextHeader />

          {!storeCode ? (
            <EmptyStoreState />
          ) : (
            <Tabs
              value={activeTab}
              onValueChange={value => updateActiveTab(value as AccessTab)}
              className="w-full"
            >
              <TabsList className="border-b border-border w-full justify-start rounded-none h-auto">
                <TabsTrigger value="users">Usuários</TabsTrigger>
                <TabsTrigger value="operators">Operadores</TabsTrigger>
              </TabsList>

              <TabsContent value="users" className="mt-4">
                <UsersTab />
              </TabsContent>

              <TabsContent value="operators" className="mt-4">
                <OperatorsTab />
              </TabsContent>
            </Tabs>
          )}
        </div>
      </ContentContainer>
    </PageLayout>
  );
};

export default StoreAccessQuery;
